import React from "react";

function clampBadgeLabel(count) {
  const numericCount = Number(count || 0);
  if (!Number.isFinite(numericCount) || numericCount <= 0) return "";
  if (numericCount > 99) return "99+";
  return String(numericCount);
}

export default function NavAlertBadge({ count = 0, className = "" }) {
  const numericCount = Number(count || 0);
  if (!Number.isFinite(numericCount) || numericCount <= 0) return null;

  return (
    <span
      aria-label={`${numericCount} unread messages`}
      className={[
        "inline-flex h-[18px] min-w-[18px] max-w-[34px] items-center justify-center rounded-full",
        "bg-[var(--Schemes-Critical,#F8533A)] px-1 text-center font-medium text-white",
        "text-[10px] leading-[18px] tracking-[-0.24px]",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {clampBadgeLabel(numericCount)}
    </span>
  );
}
